import React from 'react'
import classNames from 'classnames'
import RenderComponent from '../../renderer'
import { IssuerLogos } from '../../images'

export const ProductListComponent = (props) => {
  return(
    <div>
      {props.products.map((product, idx) => {
        const layout = props.getProductLayout(product)
        return <RenderComponent id={product.id} product_type={product.product_type} key={idx} layout={layout} />
      })}
    </div>
  )
}

export const ProductCardContainer = (props) => {
  const {
    product: { status, bad_bank_account, payment_method, is_opted_into_ach, is_opted_into_rcc, cx_dash_payoff_info } = {},
    components: {
      Alert = () => null,
      Summary = () => null,
      Details = () => null
    }
  } = props
  const achOptedIn = payment_method === 'ach' && is_opted_into_ach
  const rccOptedIn = payment_method === 'rcc' && is_opted_into_rcc
  const currentBadBankOptedIn = (status === 'current' && bad_bank_account && (achOptedIn || rccOptedIn))
  const pendingPayoff = cx_dash_payoff_info && cx_dash_payoff_info.payoff_info

  // Need to inline color b/c legacy_production is too out of date with frontend/master to create a proper class
  // We are using all loan-card--past-due styles besides color
  if (pendingPayoff) {
    var pendingPayoffStyle = {
      border: '1px solid #f0ad4e'
    }
  } else {
    var pendingPayoffStyle = {}
  }

  var styleName = classNames({
    'loan-card': true,
    'loan-card--past-due': pendingPayoff || status === 'late' || currentBadBankOptedIn,
    'loan-card--process-complete': !pendingPayoff && (status === 'current' || status === 'applied'),
    'loan-card--paid-off': !pendingPayoff && status === 'paid_off',
    'loan-card--debt-buyer': !pendingPayoff && status === 'charged_off',
    'freeze-loan': !pendingPayoff && (status === 'charged_off' || status === 'paid_off')
  });

  return(
    <section styleName={styleName} style={pendingPayoffStyle}>
      <Alert />
      <Summary />
      <Details />
    </section>
  )
}
export const LoanCardAlertCta = (props) => {
  const { cta = () =>{}, product = {}, product: { status } = {}, t } = props
  return (
    <div styleName="loan-card__alert-cta">
      <a href={cta(product.id)} styleName="button button--alert">
        <span>{t(`product.alert.cta`)}</span>
        <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
      </a>
    </div>
  )
}

export const LoanCardAlertBadBank = (props) => {
  const { badBankAction = () =>{}, product = {}, product: { status } = {}, t } = props
  return (
    <div styleName="loan-card__alert-cta">
      <a href={badBankAction(product.id)} styleName="button button--alert">
        <span>{t(`product.alert.bad_bank_action`)}</span>
        <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
      </a>
    </div>
  )
}

export const LoanCardAlertPendingPayoff = (props) => {
  return (
    <div styleName="loan-card__alert-cta">
    </div>
  )
}

export const IconComponent = (props) => {
  return <svg role="img" styleName="loan-card__alert-message-icon"><use xlinkHref="#icon-exclamation-circle" /></svg>
}

export const LoanCardAlert = (props) => {
  const {
    components: { Cta = () => null, Icon = () => null, BadBankAction = () => null } = {},
    product,
    product: {
      id,
      status,
      debt_buyer,
      debt_buyer_phone,
      payment_method,
      is_opted_into_ach,
      is_opted_into_rcc,
      past_due_amount_cents,
      cx_dash_payoff_info
    } = {},
    bank_account: {
      bad_account
    } = { bad_account: false},
    cta,
    badBankAction,
    t,
    notice
  } = props
  const achOptedIn = payment_method === 'ach' && is_opted_into_ach
  const rccOptedIn = payment_method === 'rcc' && is_opted_into_rcc
  const currentBadBankOptedIn = status === 'current' && bad_account && (achOptedIn || rccOptedIn)

  const pendingPayoff = cx_dash_payoff_info && cx_dash_payoff_info.payoff_info
  if (pendingPayoff) {
    var payoffMethod = pendingPayoff.payment_method
    var payoffAmount = pendingPayoff.payment_amount
    var payoffDate   = pendingPayoff.payment_date
    var pendingPayoffMessage = (payoffMethod === 'paper_check') ? t(`product.alert.message.payoff_pending_paper_check`, {currencySymbol, payoffAmount, payoffDate})
                                                                : t(`product.alert.message.payoff_pending`, {currencySymbol, payoffAmount, payoffDate})

    // Need to inline color b/c legacy_production is too out of date with frontend/master to create a proper class
    // We are using all loan-card--past-due styles besides color
    var pendingPayoffStyle = {
      background: '#f0ad4e'
    }
  } else {
    var pendingPayoffStyle = {}
  }

  if (!Number.prototype.toLocaleString) {
    Number.prototype.toLocaleString = function () {
      return this.toString();
    }
  }
  const pastDueAmount = past_due_amount_cents ? (past_due_amount_cents/100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'

  const currencySymbol               = t(`currency_symbol`)
  const lateMessage                  = t(`product.alert.message.late`, {currencySymbol, pastDueAmount})
  const lateBadBankMessage           = t(`product.alert.message.late_bad_bank`, {currencySymbol, pastDueAmount})
  const chargedOffMessage            = t(`product.alert.message.charged_off`, {debt_buyer, debt_buyer_phone})
  const paidOffMessage               = t(`product.alert.message.paid_off`)
  const currentBadBankOptedInMessage = t(`product.alert.message.current_bad_bank_opted_in`)

  const alertMessage = pendingPayoff ? pendingPayoffMessage
                      : currentBadBankOptedIn ? currentBadBankOptedInMessage
                      : status === 'charged_off' ? chargedOffMessage
                      : status === 'paid_off' ? paidOffMessage
                      : (bad_account && status === 'late') ? lateBadBankMessage
                      : status === 'late' ? lateMessage
                      : ''

  const ctaDisabled = (window.avantConfig && !window.avantConfig.workflows.update_bank_account.enabled_in_customer_client) && !pendingPayoff && status !== 'late'
  const ctaDisabledAction = t(`product.alert.support_number.${status}`)
  const alertAction = ctaDisabled ? ctaDisabledAction
                       : pendingPayoff ? null
                       : (bad_account && status !== 'charged_off') ? <BadBankAction/>
                       : <Cta/>
  return(
    <div styleName="loan-card__alert" style={pendingPayoffStyle}>
      <div styleName="loan-card__alert-message">
        <h2 styleName="loan-card__alert-message-header heading heading--large">
          <Icon />
          {pendingPayoff ? '' : t(`product.alert.heading.${status}`)}
        </h2>
        <p styleName="loan-card__alert-message-copy">{alertMessage}</p>
      </div>
      { alertAction }
    </div>
  )
}

export class LoanToolTip extends React.Component{
  constructor(props, context){
    super(props, context)
    this.state = {open: false}
    this.loanToolTipClickDocument = this.loanToolTipClickDocument.bind(this)
  }

  loanToolTipClickDocument(event){
    const { target } = event
    const { anchor, svg, use } = this.refs
    if(target == anchor || target == svg || target == use) return;
    this.setState({open: false})
  }

  componentDidMount(){
    document.addEventListener('click', this.loanToolTipClickDocument)
  }

  componentWillUnmount(){
    document.removeEventListener('click', this.loanToolTipClickDocument)
  }

  render(){
    const { t } = this.props
    const disclaimerStyle = classNames({
      'tooltip__pane': true,
      'tooltip__pane--open': this.state.open
    })

    return(
      <span>
        <a href="javascript:void(0)" styleName="tooltip" data-tooltip ref='anchor' onClick={() => this.setState({open: true})}>
          <svg ref='svg' role="img" styleName="tooltip__icon"><use ref='use' xlinkHref="#icon-exclamation-circle" /></svg>
        </a>
        <span styleName={disclaimerStyle}>{t(`product.tooltip`)}</span>
      </span>
    )
  }
}

export const LoanAutoPay = (props) => {
  const { product: { is_autopay } = {}, t } = props
  const autopayStyle = classNames({
    'loan-card__payment-autopay': true,
    [`loan-card__payment-autopay--${is_autopay ? 'on' : 'off'}`]: true
  });
  return(
    <div styleName={autopayStyle}>
      <small styleName="label loan-card__payment-autopay-status">
        Autopay <span>{t(`product.is_autopay.${is_autopay}`)}</span>
      </small>
    </div>
  )
}

export const LoanCardDetails = (props) => {
  const {
    t,
    product: {
      id,
      is_autopay,
      bank_name,
      bank_account_last_4,
      principal_progress_percentage,
      principal_paid_pretty,
      principal_paid_cents,
      amount_pretty: product_amount_pretty
    } = {},
    payment: {
      eff_date,
      eff_date_pretty,
      amount_pretty
    } = {},
    loanCardCta,
    components: {
      ToolTip = () => null,
      ViewProduct = () => null,
      NextPayment = () => null
    } ={}
  } = props
  const formatted_principal_paid = (principal_paid_cents < 0) ? `${t('currency_symbol')}0` : principal_paid_pretty
  return(
    <div styleName="loan-card__details">
      {/* loan card payment */}
      <NextPayment />
      {/* /loan card payment */}
      {/* loan card progress */}
      <div styleName="loan-card__progress">
        <div styleName="loan-card__progress-status">
          <div styleName="loan-card__progress-status-principal">
            <svg role="img" styleName="loan-card__icon"><use xlinkHref="#icon-money" /></svg>
            <h4 styleName="loan-card__progress-status-header label label--large">
              {t('product.progress.principal_paid')}
            </h4>
            <ToolTip />
          </div>
          <div styleName="loan-card__progress-status-paid datapoint datapoint--large">
            {formatted_principal_paid}
          </div>
          <div styleName="loan-card__progress-status-limit label label--large">
            of {product_amount_pretty}
          </div>
        </div>
        {/* progress bar */}
        <div styleName="loan-card__progress-bar">
          <span styleName="loan-card__progress-loaded" style={{width: `${(principal_progress_percentage || 0) * 100}%`}} />
        </div>
        {/* /progress bar */}
      </div>
      {/* /loan card progress */}
      {/* loan card cta */}
      <ViewProduct />
      {/* /loan card cta */}
    </div>
  )
}

export const LoanNextPayment = (props) =>{
  const {
    t,
    payment: {
      id,
      eff_date,
      eff_date_pretty,
      amount_pretty,
      relevant_bank_account: {
        name: relevant_bank_name,
        acct_number_last_4: relevant_bank_account_last_4
      } = {}
    } = {},
    product: {
      is_autopay,
      bank_name,
      bank_account_last_4,
      principal_progress_percentage,
      principal_paid_pretty,
      amount_pretty: product_amount_pretty,
      cx_dash_payoff_info
    } = {},
    components: {
      PaymentInfo = () => null
    } = {}
  } = props

  const pendingPayoff = cx_dash_payoff_info && cx_dash_payoff_info.payoff_info
  if (pendingPayoff) {
    var payoffPaymentId = pendingPayoff.payment_id
    var payoffWithPaperCheck = pendingPayoff.payment_method === 'paper_check'
    var payoffWithCard = pendingPayoff.payment_method === 'card_payment'
  }

  if (pendingPayoff && id === payoffPaymentId) {
    if (payoffWithPaperCheck) {
      var paymentTypeText = 'Paper Check'
    } else if (payoffWithCard) {
      var paymentTypeText = 'Card Payment'
    }
  }
  if (!paymentTypeText) {
    var paymentTypeText = `${relevant_bank_name || bank_name} *${relevant_bank_account_last_4 || bank_account_last_4}`
  }

  return(
      <div styleName="loan-card__payment">
        <div styleName="loan-card__payment-date">
          <h4 styleName="loan-card__payment-label label label--large">
            <svg role="img" styleName="loan-card__icon"><use xlinkHref="#icon-date" /></svg>
            {t('product.payment.next_payment')}
          </h4>
          <div styleName="loan-card__payment-date-due datapoint datapoint--small">
            {eff_date_pretty}
          </div>
          <div styleName="loan-card__payment-date-via">
            <span styleName="loan-card__payment-bank">via {paymentTypeText}</span>
            {payoffWithPaperCheck || payoffWithCard ? '' : <PaymentInfo />}
          </div>
        </div>
        <div styleName="loan-card__payment-amount">
          <h4 styleName="loan-card__payment-label label label--large">
            <svg role="img" styleName="loan-card__icon"><use xlinkHref="#icon-amount" /></svg>
            {t('product.payment.amount')}
          </h4>
          <div styleName="loan-card__payment-amount-due datapoint datapoint--small-bold">
            {amount_pretty}
          </div>
        </div>
      </div>
  )
}

export const ViewLoanCta = (props) => {
  const { id } = props
  return(
    <div styleName="loan-card__cta">
      <a href={`/dashboard#/loans/${id}`} styleName="button button--secondary">
        <span>View Loan</span>
        <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
      </a>
    </div>
  )
}

export const TransferredLoanCardDetails = (props) => {
  const {
    t,
    product: {
      issuer
    } = {}
  } = props
  return(
      <div styleName="loan-card__details">
        <div styleName="process-complete__headline headline">
          {t(`product.summary.headline.${issuer}`)}
        </div>
        <div dangerouslySetInnerHTML={{__html: t(`product.summary.copy.${issuer}`)}}></div>
      </div>
  )
}

export const LoanCardSummary = (props) => {
  const {
    t,
    product: {
      issuer,
      orig_install_amount_pretty,
      apr_percentage_pretty,
      term_pretty,
      funding_date_pretty,
      id,
      amount_pretty
    } = {}
  } = props

  return(
    <div styleName="loan-card__summary">
      <h3 styleName="loan-card__summary-label label label--large">
        <svg role="img" styleName="loan-card__summary-icon loan-card__summary-icon--sm"><use xlinkHref="#icon-product" /></svg>
        <svg role="img" styleName="loan-card__summary-icon loan-card__summary-icon--lg"><use xlinkHref="#icon-certificate" /></svg>
        Personal Loan
      </h3>
      <div styleName="loan-card__summary-amount datapoint datapoint--small-bold">
          {amount_pretty}
      </div>
      <ul styleName="loan-card__summary-id">
        <li>LOAN ID #{id}</li>
        <li>Issued {funding_date_pretty}</li>
      </ul>
      <ul styleName="loan-card__summary-terms">
        <li>{term_pretty}</li>
        <li>{apr_percentage_pretty} APR</li>
        <li>{orig_install_amount_pretty}/mo.</li>
      </ul>
      <div styleName="loan-card__summary-issuer">
        <img src={IssuerLogos[issuer]} alt={issuer} styleName="loan-card__summary-logo" />
      </div>
    </div>

  )
}

